import { mapGetters, mapMutations, mapActions } from 'vuex';
import handleErrors from './utils/handleErrors';
export default {
    data: () => ({
        colorConfirm: '#FF761C'
    }),
    computed: {
        ...mapGetters([
            'user',
            'client',
            'venue',
            'rounds',
            'currentRound',
            'roundInProgress',
            'inProgress',
            'config',
            'currentPoint',
            'checklistAnswers',
            'lastRound',
            'drawer'
        ]),
        isAuthenticated() {
            return !!this.user;
        }
    },
    methods: {
        ...mapActions(['loadRoundInProgress']),
        ...mapMutations({
            setInProgress: 'inProgress',
            setRoundInProgress: 'roundInProgress',
            setCurrentRound: 'currentRound',
            setCurrentPoint: 'currentPoint',
            setLastRound: 'lastRound',
            setState: 'state',
            setDrawer: 'drawer'
        }),
        startProcessing() {
            this.setInProgress(true);
            setTimeout(() => this.stopProcessing(), 5000);
        },
        stopProcessing() {
            this.setInProgress(false);
        },
        goTo(name) {
            this.$router.push({ name });
        },
        handleErrors
    }
}